import React from 'react';
import { Box } from '@mui/material';
import {
    FilterDatatable,
    FiltersOpts,
    FlexyFilterValue,
    SerializedFlexyFilterValue,
} from '../DatatableHeader';
import { FlexyFilterCleanup } from '../FlexyFilterCleanup/FlexyFilterCleanup';
import { FlexyFilter } from '../FlexyFilter/FlexyFilter';
import useFilter from '../FlexyFilter/useFilter';
import { FlexyFilterProvider } from '../FlexyFilter/FlexyFilterProvider';

export type FieldAndValueFilter = {
    label: string;
    field: string;
    value: string;
};

export type FlexyFiltersListProps = {
    filtersOpts?: FiltersOpts;
};

export const FlexyFiltersList: React.FunctionComponent<FlexyFiltersListProps> = function (props) {
    const { filtersOpts } = props;
    const { serializeValue, unserializeValue } = useFilter();
    const activeFilters = filtersOpts?.activeFilters || {};
    const activeFiltersKeys = Object.keys(filtersOpts?.activeFilters || {});
    const filtersField = filtersOpts?.filters || [];
    const filtersKeys = filtersField.map((f) => f.field);
    const activeFiltersCount = activeFiltersKeys.filter((f) => filtersKeys.includes(f)).length;
    let cleanAllBtn = null;

    const handleChange = (filter: FilterDatatable, value: FlexyFilterValue) => {
        if ((value === null || value === '') && filtersOpts?.onFilterDelete) {
            filtersOpts?.onFilterDelete(filter.field);

            return;
        }

        if (filtersOpts?.onFilterChange) {
            filtersOpts.onFilterChange(filter.field, serializeValue(filter, value));
        }
    };

    const handleClear = (filter: FilterDatatable) => {
        filtersOpts?.onFilterDelete(filter.field);
    };

    const handleCleanup = () => {
        filtersOpts?.onFiltersClear();
    };

    const filters = filtersOpts?.filters.map((filter: FilterDatatable) => {
        const value =
            activeFilters[filter.field] !== undefined ? activeFilters[filter.field] : null;

        return (
            <FlexyFilterProvider key={filter.label}>
                <FlexyFilter
                    filter={filter}
                    value={unserializeValue(filter, value as SerializedFlexyFilterValue)}
                    onChange={handleChange}
                    onClear={handleClear}
                />
            </FlexyFilterProvider>
        );
    });

    if (activeFiltersCount > 0) {
        cleanAllBtn = <FlexyFilterCleanup onClick={handleCleanup} />;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                gap: '10px 8px',
                alignItems: 'center',
                flexWrap: 'nowrap',
                marginBottom: '1em',
            }}
        >
            {filters}
            {cleanAllBtn}
        </Box>
    );
};
